import { type RequestResult } from 'interfaces/api/client';

import { BaseApi } from '../base-api';

import {
  type IPreviewSubscriptionRequestParams,
  type IPreviewSubscriptionRequestResult,
  type CreateOrUpdateSubscriptionParams,
  type IFetchPlansResult,
  type ISubscriptionDataV3,
} from './interfaces';

export class BillingApiV3 extends BaseApi {
  protected readonly version = '3';

  createOrUpdateSubscription = (params: CreateOrUpdateSubscriptionParams) => this.put('subscription/livechat', params);
  fetchPlans = () => this.get<IFetchPlansResult>('subscription/livechat/plans');
  preview = (params: IPreviewSubscriptionRequestParams) =>
    this.post<IPreviewSubscriptionRequestResult>('subscription/livechat/preview', { ...params });

  fetchActivatedSubscriptions = (): Promise<RequestResult<ISubscriptionDataV3>> => this.get('subscriptions');

  cancelPendingChange = () => this.delete('subscription/livechat/pending');
}
